import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/api/auth.service';
import { TableloansComponent } from './tableloans/tableloans.component';
import { GraphloansComponent } from './graphloans/graphloans.component';
import { StatswidgetComponent } from './statswidget/statswidget.component';
import { TomoOrdersTodayComponent } from './tomo-orders-today/tomo-orders-today.component';
import { TomoBranchesTodayComponent } from './tomo-branches-today/tomo-branches-today.component';
import { DashboardService, TomoDashboard } from './services/api/dashboard.service';

@Component({
    selector: 'app-dashboard',
    imports: [StatswidgetComponent, GraphloansComponent, TableloansComponent, TomoOrdersTodayComponent, TomoBranchesTodayComponent],
    templateUrl: './dashboard.html',
    styleUrl: './dashboard.scss'
})
export class Dashboard implements OnInit {
    private authService = inject(AuthService);
    private dashboardService = inject(DashboardService);

    /**
     * Doctor Informante (DOCINF) y Administradora Informes (ADMINF) ven el dashboard de tomografías:
     * solo órdenes con al menos un estudio TOMO, de todas las sucursales. ROOT/ADMIN conservan el dashboard general.
     */
    isTomoDashboard = false;
    tomoLoading = false;
    tomo: TomoDashboard = { totalOrders: 0, totalStudies: 0, orders: [], branches: [] };

    ngOnInit(): void {
        const roles = this.authService.getUserRoles();
        const isReportsRole = roles.includes('ADMINF') || roles.includes('DOCINF');
        const isFullAccess = roles.includes('ROOT') || roles.includes('ADMIN');
        this.isTomoDashboard = isReportsRole && !isFullAccess;

        if (this.isTomoDashboard) {
            this.tomoLoading = true;
            this.dashboardService.getTomoToday().subscribe({
                next: (res) => {
                    this.tomo = res.data ?? this.tomo;
                    this.tomoLoading = false;
                },
                error: () => (this.tomoLoading = false)
            });
        }
    }
}
